import React from "react";
import {Button, message, Modal, Popconfirm} from "antd";
import {QueueGet, QueueUpdate} from "../../../models/queue"
import {Config} from "../../../controller/Global";
import {SignatureGet, SignaturePatch} from "../../../models/signature";
import moment from 'moment'
import AddNewWasteStream from "./AddNewWasteStream";
import {EditWasteModal} from "./popup/EditWasteModal";
const MANIFEST = Config.constant.service_type.manifest;
const _ = require('lodash');

class SingleRouteDetailPage extends React.Component {

    state = {wasteItem:null};
    fetch = (row_id) => {
        QueueGet(row_id)
            .then(response => {
                this.setState({data: response.data});
                response.data.signature ? SignatureGet(response.data.signature)
                        .then(responseSign => {
                            this.setState({signatureData: responseSign.data})
                        }) :
                    this.setState({signatureData: null});
            })
    };
    moveToRoute = (id) => {
        const requestData = {'move_to_route': false};
        QueueUpdate(id, requestData)
            .then(response => {
                message.success('Service move to queue successfully');
                this.props.onClose();
                this.props.fetchRoute()
            })
    };

    handleFacilitySign = (id) => {
        SignaturePatch(id, {"facility": true})
            .then(response => {
                this.setState({signatureData: response.data})
            })
    };

    setModelBillTo(modelBillTo) {
        this.setState({modelBillTo});
    }

    componentDidUpdate(preProps) {
        if (this.props.row_id && this.props.visible && (this.props.visible !== preProps.visible)) {
            this.fetch(this.props.row_id)
        }
    }
    showEditModal=(visible,wasteItem=null)=>{
        this.setState({editVisible:visible, wasteItem});
    };

    render() {
        const {signatureData, wasteItem, editVisible, data} = this.state;
        const footerRoute = <div className="view-route-footer">
            <Button onClick={this.props.onClose}>Close</Button>
            {signatureData && !signatureData.facility ? <Button className="back-queue-btn"
                                                                onClick={() => this.handleFacilitySign(data.signature)}>Sign
                As Facility</Button> : ''}

            {!signatureData && <Popconfirm title="Are you sure？" okText="Yes" cancelText="No"
                                           onConfirm={() => this.moveToRoute(data.id)}>
                <Button className="back-queue-btn" icon="rollback">Send Back To Queue</Button>
            </Popconfirm>}
            <Button onClick={this.props.onClose} type="primary">Okay</Button>
        </div>;
        return (
            <Modal destroyOnClose={true} onClose={this.props.onClose} title="View Details" centered
                   visible={this.props.visible}
                   footer={footerRoute} width={'75%'}
                   className="view-data-modal route-dtl-mdl">
                {data && <div className="row route-view-main">
                    <div className="col-12">
                        <div className="view-data-div">
                            <span
                                className="routeH"> {data.service.type === MANIFEST ? 'Manifest' : 'BOL'} Number</span>
                            <span>{data.service.manifest_number}</span>
                        </div>
                        <div className="view-data-div">
                            <span className="routeH">Generator</span>
                            <span>{_.get(data.workorder, 'generator.account_number')} - {_.get(data.workorder, 'generator.company_name')}</span>
                        </div>
                        <div className="view-data-div">
                            <span className="routeH">Facility</span>
                            <span>{data.service.facility.name}</span>
                        </div>
                        <div className="view-data-div">
                            <span className="routeH">Truck Id</span>
                            <span>{data.truck.truck_id}</span>
                        </div>

                        <div className="view-data-div">
                            <span className="routeH">Truck Type</span>
                            <span>{data.truck.type.type_name}</span>
                        </div>
                        <div className="view-data-div">
                            <span className="routeH">Service Type</span>
                            <span>{data.service.service_type.name}</span>
                        </div>
                        <div className="view-data-div">
                            <span className="routeH">Transporter</span>
                            <span>{data.service.transporter.name}</span>
                        </div>
                        <div className="view-data-div">
                            <span className="routeH">Service Date</span>
                            <span>{data.service.service_date}</span>
                        </div>
                        <div className="view-data-div w-100">
                            <span className="routeH">Job Description</span>
                            <span className="view-full-txt">{data.service.job_description}</span>
                        </div>
                    </div>
                    <div className="col-6 show-roles">
                        <p>Team Assigned</p>
                        <div className="roles-header-view"><span>Name</span><span>Role</span></div>
                        {data.members.map((item, index) => {
                            return <div key={index} className="roles-content-view">
                                <span>{item.member.first_name}{item.member.last_name}</span><span>{item.role}</span>
                            </div>
                        })}
                    </div>
                    <div className="col-6 show-roles waste-stream-roles">
                        <p>Waste Stream</p>
                        <div className="roles-header-view">
                            <span>Waste Stream Code</span><span>Quantity</span><span className="edit-role">Edit</span>
                        </div>
                        {data.service.waste_data.map((item, index) => {
                            return <div key={index} className="roles-content-view">
                                <span>{item.waste_stream.code}</span>
                                <span>{item.quantity}</span>
                                <span className="edit-role"><Button onClick={()=>this.showEditModal(true,item)}><i className="fa fa-pencil"/></Button></span>
                            </div>
                        })}
                        <AddNewWasteStream reload={() => this.fetch(this.props.row_id)} service={data.service} />
                        <EditWasteModal reload={() => this.fetch(this.props.row_id)} item={wasteItem} visible={editVisible} onClose={()=>this.showEditModal(false)} />
                    </div>
                    <div className="col-12 st-end-time">
                        <div className="view-data-div">
                            <span className="routeH">Start Time:</span>
                            <span>{data.dispatch ? moment(data.dispatch.start_time).format('hh.mm a') : '---'}</span>
                        </div>
                        <div className="view-data-div">
                            <span className="routeH">End Time:</span>
                            <span>{data.dispatch ? moment(data.dispatch.end_time).format('hh.mm a') : '---'}</span>
                        </div>
                    </div>
                    {signatureData && <div className="col-12 signature-div">
                        <div className="row">
                            <div className="col-sm-4 col-12">
                                <h5>Generator Signature</h5>
                                <img className="img-fluid" src={signatureData.generator}/>
                            </div>
                            <div className="col-sm-4 col-12">
                                <h5>Transporter Signature</h5>
                                <img className="img-fluid" src={signatureData.transporter}/>
                            </div>
                            {signatureData.facility &&
                            <div className="col-sm-4 col-12">
                                <h5>Facility Signature</h5>
                                <img className="img-fluid" src={signatureData.facility_url}/>
                            </div>}
                        </div>
                    </div>}

                </div>}
            </Modal>
        );
    }
}

export const SingleRouteDetail = SingleRouteDetailPage;



// WEBPACK FOOTER //
// ./src/pages/dispatch/routes/SingleRouteDetail.jsx